
import React, { Component } from "react";

class EmailAlreadyExists extends Component {

    render() {
        const { os } = this.props;
        return <section id="errorComponent">
        <div>
            <div className="header-image">
                <img src="assets/images/hand.png" />
            </div>
            <div className="icon">
                <img src="assets/images/icon_download.svg" />
            </div>
            <div>
                <div className="wrap-content-email">
                    <h2 className="blue">
                        <strong>Este e-mail já foi cadastrado</strong> na escala {this.props.department}.
                    </h2>
                    <p>
                        Para finalizar é só acessar sua escala no aplicativo!
                    </p>
                
                    {
                        os.includes("OS") &&
                        <div className="download">
                            <p className="download">
                            Baixe para Iphone
                            </p>
                            <a href="https://itunes.apple.com/br/app/escala/id998551095?mt=8"><img src="assets/images/badge_appstore.svg"/></a>
                        </div>
                        }
                        {
                        os.includes("Android") &&
                        <div className="download">
                            <p>
                            Baixe para o Android
                            </p>
                            <a href="https://play.google.com/store/apps/details?id=br.einstein.escala&hl=pt_BR"><img src="assets/images/badge_googleplay.svg"/></a>
                        </div>
                        }
                        {
                        !os.includes("Android") && !os.includes("OS") &&
                        <div className="download">
                            <p>
                                Faça o Download
                            </p>
                            <a href="https://play.google.com/store/apps/details?id=br.einstein.escala&hl=pt_BR"><img src="assets/images/badge_googleplay.svg"/></a>
                            <a href="https://itunes.apple.com/br/app/escala/id998551095?mt=8"><img src="assets/images/badge_appstore.svg"/></a>
                        </div>
                    }
                 </div>
            </div>
        </div>
    </section>
    }
} export default EmailAlreadyExists;


// WEBPACK FOOTER //
// ./src/app/home/container/emailAlreadyExists.js